import axios from 'axios';
import { baseUrl } from '@/config';
import { forEach } from 'lodash';

export default {
  /**
   * [장비등록 > 네트워크] 관리대상 등록 화면의 네트워크 장비 목록을 조회한다.
   * @author najongdang
   * @return {Object} [response 객체]
   */
  getNetdeviceList(params) {
    return axios.post(`${baseUrl}/settings/device-registration-nms/get-netdevice-list.do`, params);
  },
  /**
   * [장비등록 > 네트워크] 관리대상 등록 화면의 네트워크 장비 목록을 수정한다.
   * @author najongdang
   * @return {Object} [response 객체]
   */
  updateNetdeviceList(params) {
    return axios.post(`${baseUrl}/settings/device-registration-nms/update-netdevice-list.do`, params);
  },
  /**
   * [장비등록 > 네트워크] 관리대상 등록 화면의 네트워크 장비 목록을 삭제한다.
   * @author najongdang
   * @return {Object} [response 객체]
   */
  deleteNetdeviceList(params) {
    return axios.post(`${baseUrl}/settings/device-registration-nms/delete-netdevice-list.do`, params);
  },
  /**
   * [장비등록 > 네트워크] 관리대상 등록 화면의 장비별 인터페이스 목록을 조회한다.
   * @author najongdang
   * @return {Object} [response 객체]
   */
  getNetinterfaceList(params) {
    return axios.post(`${baseUrl}/settings/device-registration-nms/get-netinterface-list.do`, params);
  },
  /**
   * [[장비등록 > 네트워크] 관리대상 등록 화면의 최근 등록장비 갯수를 조회한다.
   * @author najongdang
   * @return {Object} [response 객체]
   */
  getRecentRegisteredNetdeviceCount() {
    return axios.get(`${baseUrl}/settings/device-registration-nms/get-recent-registered-netdevice-count.do`);
  },
  /**
   * [장비등록 > 네트워크] 관리대상 등록 화면의 장비별 인터페이스 리스트를 수정한다.
   * @author najongdang
   * @return {Object} [response 객체]
   */
  updateNetinterfaceList(params) {
    return axios.post(`${baseUrl}/settings/device-registration-nms/update-netinterface-list.do`, params);
  },
  /**
   [장비등록 > 네트워크] 관리대상 등록 화면에서 netdevice를 추가한다.
   * @author najongdang
   * @return {Object} [response 객체]
   */
  insertNetdevice(params) {
    return axios.post(`${baseUrl}/settings/device-registration-nms/insert-netdevice.do`, params);
  },
  /**
   [장비등록 > 네트워크] 모델링방식 화면에서 모델링방식 목록을 조회한다.
   * @author najongdang
   * @return {Object} [response 객체]
   */
  getModelingMethodList(params) {
    return axios.post(`${baseUrl}/settings/device-registration-nms/get-modeling-method-list.do`, params);
  },
  /**
   [장비등록 > 네트워크] 모델링방식 화면에서 모델링방식을 추가한다.
   * @author najongdang
   * @return {Object} [response 객체]
   */
  insertModelingMethod(params) {
    return axios.post(`${baseUrl}/settings/device-registration-nms/insert-modeling-method.do`, params);
  },
  /**
   [장비등록 > 네트워크] 모델링방식 화면에서 모델링방식을 수정한다.
   * @author najongdang
   * @return {Object} [response 객체]
   */
  updateModelingMethod(params) {
    return axios.post(`${baseUrl}/settings/device-registration-nms/update-modeling-method.do`, params);
  },
  /**
   [장비등록 > 네트워크] 모델링방식 화면에서 TELNET, SSH 모델링방식을 추가시 필요한 템플릿 목록을 조회한다.
   * @author najongdang
   * @return {Object} [response 객체]
   */
  getLoginTemplateList() {
    return axios.get(`${baseUrl}/settings/device-registration-nms/get-login-template-list.do`);
  },
  /**
   [장비등록 > 네트워크] 모델링방식 화면에서 모델링방식 리스트를 삭제합니다.
   * @author najongdang
   * @return {Object} [response 객체]
   */
  deleteModelingMethodList(params) {
    return axios.post(`${baseUrl}/settings/device-registration-nms/delete-modeling-method-list.do`, params);
  },
  /**
   [장비등록 > 네트워크] 모델링방식 화면에서 모델링방식 수정을 위한 정보를 조회한다.
   * @author najongdang
   * @return {Object} [response 객체]
   */
  getNmsCredentialValueList(params) {
    return axios.post(`${baseUrl}/settings/device-registration-nms/get-nms-credential-value-list.do`, params);
  },
  /**
   [장비등록 > 네트워크] 네트워크 등록 마법사의 IP 검색대역 리스트를 가지고 온다
   * @author najongdang
   * @return {Object} [response 객체]
   */
  getNmsAutodiscoveryList(params) {
    return axios.post(`${baseUrl}/settings/device-registration-nms/get-nms-autodiscovery-list.do`, params);
  },
  /**
   [장비등록 > 네트워크] 네트워크 등록 마법사의 수집서버목록을 가지고 온다
   * @author najongdang
   * @return {Object} [response 객체]
   */
  getAgentMgrGrpList() {
    return axios.get(`${baseUrl}/settings/device-registration-nms/get-agent-mgr-grp-list.do`);
  },
  /**
   * [장비등록 > 네트워크] 네트워크 등록 마법사 IP 검색대역의 단일 IP 주소 중복 체크
   * @author najongdang
   * @return {Object} [response 객체]
   */
  checkSpotIpaddresssValidation(params) {
    return axios.post(`${baseUrl}/settings/device-registration-nms/check-spot-ipaddress-validation.do`, params);
  },
  /**
   [장비등록 > 네트워크] 네트워크 등록 마법사의 IP 검색대역을 추가한다.
   * @author najongdang
   * @return {Object} [response 객체]
   */
  insertNmsAutodiscovery(params) {
    return axios.post(`${baseUrl}/settings/device-registration-nms/insert-nms-autodiscovery.do`, params);
  },
  /**
   [장비등록 > 네트워크] 네트워크 등록 마법사에서 선택된 IP검색대역 목록을 삭제한다.
   * @author najongdang
   * @return {Object} [response 객체]
   */
  deleteNmsAutodiscoveryList(params) {
    return axios.post(`${baseUrl}/settings/device-registration-nms/delete-nms-autodiscovery-list.do`, params);
  },
  /**
   [장비등록 > 네트워크] 네트워크 등록 마법사의 IP 검색대역을 수정한다.
   * @author najongdang
   * @return {Object} [response 객체]
   */
  updateNmsAutodiscovery(params) {
    return axios.post(`${baseUrl}/settings/device-registration-nms/update-nms-autodiscovery.do`, params);
  },
  /**
   [장비등록 > 네트워크] 네트워크 등록 마법사에서 모델링을 수행한다.
   * @author najongdang
   * @return {Object} [response 객체]
   */
  executeAutodiscovery(params) {
    return axios.post(`${baseUrl}/settings/device-registration-nms/execute-autodiscovery.do`, params);
  },
  /**
   * [장비등록 > 네트워크] 모델링 스케쥴에서 스케쥴 목록을 가지고 온다
   * @author najongdang
   * @return {Object} [response 객체]
   */
  getModelingScheduleList(params) {
    return axios.post(`${baseUrl}/settings/device-registration-nms/get-modeling-schedule-list.do`, params);
  },
  /**
   [장비등록 > 네트워크] 모델링 스케줄을 수행한다.
   * @author najongdang
   * @return {Object} [response 객체]
   */
  executeModelingSchedule(scheduleId) {
    return axios.get(`${baseUrl}/settings/device-registration-nms/execute-modeling-schedule.do`, { params: { scheduleId } });
  },
  /**
   * 모델링 스케쥴의 진행률을 조회한다.
   * @author Ju
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  getModelingScheduleProcessRateList(params) {
    return axios.post(`${baseUrl}/settings/device-registration-nms/get-modeling-schedule-process-rate-list.do`, params);
  },
  /**
   * 모델링 IP 대역 전체에 대한 진행률을 조회한다.
   * @author Ju
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  getModelingScanProgressRate(params) {
    return axios.post(`${baseUrl}/settings/device-registration-nms/get-modeling-scan-process-rate.do`, params);
  },
  /**
   * [장비등록 > 네트워크] 모델링 스케쥴 수정 시 필요한 등록 마법사 정보를 가지고 온다.
   * @author najongdang
   * @return {Object} [response 객체]
   */
  getRegistMagicianInfo(params) {
    return axios.post(`${baseUrl}/settings/device-registration-nms/get-regist-magician-info.do`, params);
  },
  /**
   * [장비등록 > 네트워크] 모델링 스케쥴화면에서 선택된 스케쥴 목록을 삭제한다
   * @author najongdang
   * @return {Object} [response 객체]
   */
  deleteScheduleList(params) {
    return axios.post(`${baseUrl}/settings/device-registration-nms/delete-schedule-list.do`, params);
  },
  /**
   * [장비등록 > 네트워크] 모델링 스케쥴화면에서 선택된 스케쥴 목록을 수정한다
   * @author najongdang
   * @return {Object} [response 객체]
   */
  updateScheduleList(params) {
    return axios.post(`${baseUrl}/settings/device-registration-nms/update-schedule-list.do`, params);
  },
  /**
   * 네트워크 장비에 대한 동기화 기능을 수행한다.
   * @author Ju
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  syncNetdevice(params) {
    return axios.post(`${baseUrl}/settings/device-registration-nms/execute-sync-netdevice.do`, params);
  },
  /**
   * 설정 > 초기설정 > 장비등록 > 네트워크 장비목록 - 엑셀출력 기능
   * @author Song
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  excelExportNetdeviceList(params) {
    return axios.post(`${baseUrl}/settings/device-registration-nms/excel-export-netdevice-list.do`, params);
  },
  /**
   * 설정 > 초기설정 > 장비등록 > 네트워크 장비목록 - 엑셀출력 기능
   * @author Song
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  excelExportNetinterfaceList(param) {
    const form = document.createElement('form');
    form.action = `${baseUrl}/settings/device-registration-nms/excel-export-netinterface-list.do`;
    form.method = 'post';
    forEach(param, (value, key) => {
      const hiddenField = document.createElement('input');
      hiddenField.setAttribute('type', 'hidden');
      hiddenField.setAttribute('name', key);
      hiddenField.setAttribute('value', param[key]);
      form.appendChild(hiddenField);
    });
    document.body.appendChild(form);
    form.submit();
    document.body.removeChild(form);
  },
  /**
   * 설정 > 초기설정 > 장비등록 > 네트워크 장비 모델링 결과를 조회한다. (모델링 팝업)
   * @author Song
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  getNetdeviceModelingResultList(params) {
    return axios.post(`${baseUrl}/settings/device-registration-nms/get-netdevice-modeling-result-list.do`, params);
  },
  /**
   * 설정 > 초기 설정 > 장비등록 > 네트워크 관리대상 엑셀 입력
   * @author najong
   * @return {[type]}   [description]
   */
  excelImportNetdeviceList(params) {
    return axios.post(`${baseUrl}/settings/device-registration-nms/excel-import-netdevice-list.do`, params);
  },
  /**
   * 설정 > 초기 설정 > 네트워크 장비등록 > 등록 마법사 > IP 검색대역 > 엑셀 출력
   * @author 정성윤
   * @return {[type]}        [description]
   */
  exportIpSearchList() {
    const form = document.createElement('form');
    form.action = `${baseUrl}/settings/device-registration-nms/export-nms-ip-search-list.do`;
    form.method = 'post';
    document.body.appendChild(form);
    form.submit();

    document.body.removeChild(form);
  },
  /**
   * 설정 > 초기 설정 > 네트워크 장비등록 > 등록 마법사 > IP 검색대역 > 엑셀 입력
   * @author 정성윤
   * @return {[type]}   [description]
   */
  importIpSearchList(params) {
    return axios.post(`${baseUrl}/settings/device-registration-nms/import-nms-ip-search-list.do`, params);
  },
};



// WEBPACK FOOTER //
// ./src/api/settings/common/device-registration-nms.js